
  <div class="cards-container">
    <div class="card-row" *ngFor="let row of getRows(topBuyInvoices)">
      <div class="person-card" *ngFor="let companie of row">
        <h3 style="color: #003c8a;">{{ companie.clientName || 'Sin Informacion' }}</h3>
        <p>{{ companie.clientRut }}</p>
        <hr>
        <p><strong>Monto:</strong> {{ companie.totalAmount | currency : "CLP" : "symbol" }}</p>
        <p><strong>N° Documentos:</strong> {{ companie.numberInvoice }}</p>
        <p><strong>Último Documento:</strong> {{ companie.dateLastDocument | date : "dd/MM/yyyy" }}</p>
      </div>
    </div>
    <div *ngIf="topBuyInvoices.length==0" style="text-align: center; width: 100%;">
      <mat-card class="cardWithShadow">
        <mat-card-content class="p-24">
          <h3>No hay Informacion</h3>
        </mat-card-content>
      </mat-card>
    </div>
  </div>